export const servers = [
  { value: 'NA1', name: 'NA' },
  { value: 'EUW1', name: 'EUW' },
  { value: 'EUN1', name: 'EUNE' },
  { value: 'BR1', name: 'BR' },
  { value: 'KR', name: 'KR' },
  { value: 'LA1', name: 'LAN' },
  { value: 'LA2', name: 'LAS' },
  { value: 'OC1', name: 'OCE' },
  { value: 'JP1', name: 'JP' },
  { value: 'TR1', name: 'TR' },
  { value: 'RU', name: 'RU' }
]

export const refreshLimit = 1000 * 60 * 60 * 12

// live version: 
export const cloudFunctionBaseUrl = 'https://us-central1-town-faker.cloudfunctions.net/'
// local version: 
// export const cloudFunctionBaseUrl = 'http://localhost:5000/town-faker/us-central1/'
